export default __webpack_public_path__ + "static/media/element_20.d4ddd6c8.jpg";